import '@toast-ui/editor/dist/toastui-editor.css';
import { Viewer } from '@toast-ui/react-editor';
import React from 'react';

export interface MdViewProps {
  text?: string;
}
function MdViewer({ text }: MdViewProps) {
  return <Viewer initialValue={text ?? ''} />;
}

export default MdViewer;
